import { useEffect, useState } from 'react';

/**
 * Ligne verticale indiquant l'heure actuelle sur une timeline de regulation
 * (demande utilisateur : "ajuster la timeline en fonction de l'horaire reel").
 * Se met a jour toutes les 30s ; n'affiche rien si `getPositionPercent`
 * renvoie null (heure actuelle hors de la plage/journee affichee).
 */
interface NowLineProps {
  getPositionPercent: () => number | null;
}

export function NowLine({ getPositionPercent }: NowLineProps) {
  const [, forceTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => forceTick((t) => t + 1), 30000);
    return () => clearInterval(interval);
  }, []);

  const position = getPositionPercent();
  if (position === null) return null;

  return (
    <div
      className="absolute top-0 bottom-0 w-0.5 bg-red-500 z-20 pointer-events-none"
      style={{ left: `${position}%` }}
      title="Heure actuelle"
    >
      <div className="absolute -top-1.5 -left-[5px] w-3 h-3 rounded-full bg-red-500" />
    </div>
  );
}

export default NowLine;
